module.exports = __webpack_public_path__ + "static/img/IOTImg.39416b1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/IOTImg.webp
// module id = rVJb
// module chunks = 1